import { render, staticRenderFns } from "./ImportCsv.vue?vue&type=template&id=b4b3e21e&scoped=true&"
import script from "./ImportCsv.vue?vue&type=script&lang=ts&"
export * from "./ImportCsv.vue?vue&type=script&lang=ts&"
import style0 from "./ImportCsv.vue?vue&type=style&index=0&id=b4b3e21e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b3e21e",
  null
  
)

export default component.exports